import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, ChevronRight } from "lucide-react";

export function PageHero({ title, subtitle, crumb }) {
  return (
    <section className="bg-[#0A2540] relative overflow-hidden" data-testid="page-hero">
      <div className="absolute inset-0 hero-grid opacity-30" />
      <div className="absolute top-0 right-0 w-[400px] h-[400px] bg-blue-500/10 rounded-full blur-[120px]" />
      <div className="container mx-auto max-w-7xl px-6 py-16 lg:py-20 relative">
        <div className="flex items-center gap-1.5 text-[13px] text-slate-400 mb-4">
          <Link to="/" className="hover:text-white">Home</Link>
          <ChevronRight className="w-3.5 h-3.5" />
          <span className="text-white">{crumb || title}</span>
        </div>
        <h1 className="text-4xl md:text-5xl font-bold text-white leading-tight" style={{ fontFamily: "Outfit" }}>{title}</h1>
        {subtitle && <p className="text-slate-300 mt-4 max-w-3xl leading-relaxed">{subtitle}</p>}
      </div>
    </section>
  );
}

export function CTA() {
  return (
    <section className="py-16 bg-slate-50/60 border-t border-slate-100">
      <div className="container mx-auto max-w-7xl px-6">
        <div className="rounded-2xl bg-gradient-to-br from-[#0A2540] to-[#0F3560] p-10 md:p-14 flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-2" style={{ fontFamily: "Outfit" }}>Ready to transform your business?</h3>
            <p className="text-slate-300 text-[15px]">Book a free consultation with our experts today.</p>
          </div>
          <Link to="/contact">
            <button className="bg-[#2563EB] hover:bg-[#1D4ED8] text-white font-semibold px-6 py-3 rounded-md inline-flex items-center gap-2 shadow-lg shadow-blue-600/30 transition-colors" data-testid="cta-book-btn">
              Book Free Consultation <ArrowRight className="w-4 h-4" />
            </button>
          </Link>
        </div>
      </div>
    </section>
  );
}
